import { getStack } from '@/lib/contentstack/stack';
import Image from 'next/image';

export default async function ImageReference({
  uid,
  parent_uid,
  className,
  style
}) {
  const { props } = await fetchImage(uid);
  const { image_uid, title, url } = props.document;

  return (
    <Image
      id={parent_uid + '_' + image_uid}
      src={url}
      alt={title}
      width="576"
      height="376"
      sizes="576px"
      className={className}
      style={style}
    />
  );
}

export async function fetchImage(uid) {
  const assetUid = uid;
  const Stack = getStack();
  const query = Stack.Assets(assetUid).addParam('include_dimension', 'true');

  const response = await query.toJSON().fetch();

  const document = {
    image_uid: response.uid,
    dimension: response.dimension,
    tags: response.tags,
    title: response.title,
    locale: response.publish_details.locale,
    url: response.url
  };

  return {
    props: {
      document // Convert each entry to JSON
    }
  };
}
